export default "__VITE_ASSET__RHOGLE4u__"